class TagsFilter extends HTMLElement {
    constructor() {
      super();
      this.tagButtons = null;
      this.allTopicsButton = null;
    }
  
    connectedCallback() {
      this.initialize();
    }
  
    initialize() {
      this.tagButtons = this.querySelectorAll("[data-blog-tag]");
      this.allTopicsButton = this.querySelector("[data-blog-tag='all']");
  
      this.setupEventListeners();
      this.setInitialActiveState();
    }
  
    setupEventListeners() {
      this.tagButtons.forEach((button) => {
        button.addEventListener("click", () => this.handleTagClick(button));
      });
    }
  
    handleTagClick(button) {
      const selectedTag = button.getAttribute("data-blog-tag");
      let currentTags = this.getCurrentTagsFromURL();
      const baseURL = this.getBaseURL();
  
      if (selectedTag === "all") {
        this.updateURL(baseURL);
        this.updateActiveButton(this.allTopicsButton);
      } else {
        currentTags = this.toggleTagInList(currentTags, selectedTag);
        
        const newPath = currentTags.length ? `${baseURL}/tagged/${currentTags.join("+")}` : baseURL;
        this.updateURL(newPath);
        this.updateActiveButton(button, currentTags);
      }
    }
  
    getCurrentTagsFromURL() {
      const path = window.location.pathname;
      return path.includes("/tagged/") ? path.split("/tagged/")[1].split("+") : [];
    }
  
    toggleTagInList(tags, tag) {
      const tagIndex = tags.indexOf(tag);
      
      if (tagIndex === -1) {
        return [...tags, tag];
      } else {
        return tags.filter((t) => t !== tag);
      }
    }     
  
    getBaseURL() {
      const currentPath = window.location.pathname;
      const basePath = currentPath.split('/tagged')[0];
      return window.location.origin + basePath;
    }
    
    updateURL(newPath) {
      window.location.href = newPath;
    }
  
    updateActiveButton(activeButton, activeTags = []) {
      this.tagButtons.forEach((button) => button.classList.remove("tag-active"));
  
      if (activeTags.length === 0 || activeButton === this.allTopicsButton) {
        this.allTopicsButton.classList.add("tag-active");
      } else {
        activeButton.classList.add("tag-active");
      }
    }
  
    setInitialActiveState() {
      const currentTags = this.getCurrentTagsFromURL();
  
      if (currentTags.length) {
        this.tagButtons.forEach((button) => {
          if (currentTags.includes(button.getAttribute("data-blog-tag"))) {
            button.classList.add("tag-active");
          }
        });
      } else {
        this.allTopicsButton.classList.add("tag-active");
      }
    }
}
  
window.customElements.define("tags-filter", TagsFilter);  



class BlogSearch extends HTMLElement {
  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    const searchInput = this.querySelector("#blogSearchInput");
    searchInput.addEventListener("input", () => this.searchBlogPosts());
  }

  searchBlogPosts() {
    const input = this.querySelector("#blogSearchInput");
    const resultList = this.querySelector("#search-results-list");
    const blogList = this.querySelector("#blog-list");
    const grid = this.querySelector("#blog-posts-grid");
    const items = grid.getElementsByClassName("blog-post-item");

    if (!input.value.trim()) {
      resultList.style.display = "none";
      blogList.style.display = "block";
      return;
    }

    const filter = input.value.toUpperCase();
    resultList.style.display = "block";
    blogList.style.display = "none";

    Array.from(items).forEach((item) => {
      const title = item.querySelector("h3");
      const txtValue = title?.textContent || title?.innerText || "";
      item.style.display = txtValue.toUpperCase().includes(filter) ? "" : "none";
    });
  }
}

window.customElements.define("blog-search", BlogSearch);